// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_913f5d7","createGameModal":"_87f664f","body":"_79b129a","content":"_2723f1f","container":"_930f43a","inner":"_53c0738","bannerBg":"_1b0c12d"};